module.exports = __webpack_public_path__ + "media/images/Kyselyt-64d4677488b8b04e01d6b693e90cc18c.svg";